import React from 'react';
import { IconButton, useColorMode, useColorModeValue } from '@chakra-ui/react';
import { FaSun, FaMoon } from 'react-icons/fa';

export default function ColorModeToggle(props) {
    const { toggleColorMode } = useColorMode();
    const Icon = useColorModeValue(FaMoon, FaSun);
    const label = useColorModeValue('Modo Oscuro', 'Modo Claro');
    const iconColor = useColorModeValue('brand.800', 'white');
    const btnScheme = useColorModeValue('brand', 'whiteAlpha');

    return (
        <IconButton
            icon={<Icon />}
            onClick={toggleColorMode}
            aria-label={label}
            variant="ghost"
            colorScheme={btnScheme}
            color={iconColor}
            {...props}
        />
    );
}
